import { format } from "date-fns";
import { toCurrency, createMarkup } from "../../../utils";

export const NOTE_COLUMNS = [
  {
    Header: "Note",
    accessor: "Note",
    Cell: ({ cell }) => createMarkup(cell.value)
  },
  {
    Header: "Modified On",
    accessor: "ModifiedDateTime",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy - k:mm:ss") : null
  },
  {
    Header: "Modified By",
    accessor: "ModifiedBy"
  },
  {
    Header: "Created On",
    accessor: "CreatedDateTime",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy - k:mm:ss") : null
  },
  {
    Header: "Created By",
    accessor: "CreatedBy"
  }
];

export const CUSTOMER_COLUMNS = [
  {
    Header: "Customer No",
    accessor: "CustomerNo"
  },
  {
    Header: "Name",
    accessor: "Name"
  },
  {
    Header: "Bill To",
    accessor: "BillToCust",
    id: "BillTo",
    Cell: ({ cell }) => (cell.value ? "Yes" : "No")
  },
  {
    Header: "Order",
    accessor: "OrderCust",
    id: "OrderCust",
    Cell: ({ cell }) => (cell.value ? "Yes" : "No")
  },
  {
    Header: "Active",
    accessor: "Active",
    Cell: ({ cell }) => (cell.value ? "Yes" : "No")
  },
  {
    Header: "ELD Status",
    accessor: "ELDStatus.CodeDescription"
  },
  {
    Header: "Customer Group",
    id: "CustomerType",
    accessor: "CustomerType.CodeDescription"
  },
  {
    Header: "Payment Term",
    id: "PaymentTerm",
    accessor: "PaymentTerm.TermDescription"
  },
  {
    Header: "Address 1",
    accessor: "Address1"
  },
  {
    Header: "Address 2",
    accessor: "Address2"
  },
  {
    Header: "City",
    accessor: "City"
  },
  {
    Header: "State",
    accessor: "State"
  },
  {
    Header: "Zip",
    accessor: "Zip"
  },
  {
    Header: "Telephone",
    accessor: "Telephone"
  },
  {
    Header: "Fax No",
    accessor: "FaxNo"
  },
  {
    Header: "Billing Contact",
    accessor: "BillingContactName"
  },
  {
    Header: "Last Sale Date",
    accessor: "LastSaleDate",
    Cell: ({ cell }) => {
      const { value } = cell;
      if (value !== null && typeof value !== "undefined") {
        const date = new Date(value)
          .toISOString()
          .substr(0, 10)
          .split("-");
        return format(
          new Date(date[0], parseInt(date[1]) - 1, date[2]),
          "MM/dd/yyyy"
        );
      }
      return "N/A";
    }
  },
  {
    Header: "Last Sale Amount",
    accessor: "LastSaleAmount",
    Cell: ({ cell }) =>
      cell.value ? toCurrency(cell.value, "USD", "en-US") : null
  }
];

export const CUSTOMER_CONTACT_COLUMNS = [
  {
    Header: "First Name",
    accessor: "FirstName",
    id: "FirstName"
  },
  {
    Header: "Last Name",
    accessor: "LastName",
    id: "LastName"
  },
  {
    Header: "Job Title",
    accessor: "JobTitle",
    id: "JobTitle"
  },
  {
    Header: "Phone #",
    accessor: "BusinessPhone",
    id: "BusinessPhone"
  },
  {
    Header: "Mobile #",
    accessor: "MobilePhone",
    id: "MobilePhone"
  },
  {
    Header: "Fax #",
    accessor: "FaxNo",
    id: "FaxNo"
  },
  {
    Header: "Email",
    accessor: "EmailAddress",
    id: "EmailAddress"
  },
  {
    Header: "Active",
    accessor: "Active",
    id: "Active"
  }
];
